import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "puertalia-cookie-consent";

export const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    }, []);

    const choose = (value) => {
        localStorage.setItem(STORAGE_KEY, value);
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 120, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 120, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:bottom-5 sm:left-5 sm:max-w-md"
                    data-testid="cookie-banner"
                    role="dialog"
                    aria-label="Aviso de cookies"
                >
                    <div className="rounded-2xl border border-brand-navy/10 bg-white p-5 shadow-2xl dark:border-white/10 dark:bg-brand-ink">
                        <div className="flex items-start gap-3">
                            <span className="mt-0.5 rounded-lg bg-brand-orange/10 p-2 text-brand-orange">
                                <Cookie className="h-5 w-5" />
                            </span>
                            <p className="text-xs leading-relaxed text-brand-navy/75 dark:text-white/70">
                                Usamos cookies propias y de terceros para que la web funcione
                                y para analizar el tráfico de forma anónima. Puedes aceptar o
                                rechazar. Más información en nuestra{" "}
                                <Link to="/cookies" className="font-bold text-brand-orange underline underline-offset-2" data-testid="cookie-policy-link">
                                    política de cookies
                                </Link>
                                .
                            </p>
                        </div>
                        <div className="mt-4 flex gap-3">
                            <button
                                onClick={() => choose("accepted")}
                                data-testid="cookie-accept-btn"
                                className="flex-1 rounded-full bg-brand-orange px-4 py-2.5 font-sans text-sm font-bold text-white transition-colors duration-200 hover:bg-brand-orangedark"
                            >
                                Aceptar
                            </button>
                            <button
                                onClick={() => choose("rejected")}
                                data-testid="cookie-reject-btn"
                                className="flex-1 rounded-full border border-brand-navy/20 px-4 py-2.5 font-sans text-sm font-bold text-brand-navy transition-colors duration-200 hover:bg-brand-navy/5 dark:border-white/20 dark:text-white dark:hover:bg-white/10"
                            >
                                Rechazar
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
